module.exports = __webpack_public_path__ + "img/icn_resize_pens_tool.19cf5df9.svg";